var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('IconDownload',{staticClass:"icon-download"}),_c('p',{staticClass:"button-text"},[_vm._v("Download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }